export default function (...args)
{
	/** Valores marcados no DOM (estado checked, não só o atributo HTML [checked]). */
	const checkedValuesFromDom = (selector) =>
		Array.from(document.querySelectorAll(`${selector}:checked`)).map(node => node.value).join(',');

	return {

		events: ['change'],

		getValue(default_value = checkedValuesFromDom(this.selector), _this = this)
		{
			return this.safeProtoCall(default_value, _this);
		},

		refresh()
		{
			let values = this.getValue().split(',').filter(Boolean);
			let nodes = document.querySelectorAll(this.selector);
			nodes.forEach(node =>
			{
				node.checked = values.includes(node.value);
			});
		},

		/** Evita que syncFromDom() do field trate só o 1º checkbox e grave "0"/"1" no lugar da lista. */
		syncFromDom()
		{
			const v = checkedValuesFromDom(this.selector);
			this.setValue(v);
		},

		handleEvents(ev)
		{
			let values = this.getValue().split(',').filter(Boolean);
			let index = values.findIndex(value => value == ev.target.value);
			if (index < 0)
				values.unshift(ev.target.value);	// Add if not found
			else
				values.splice(index, 1);			// Remove if found
			this.setValue(values.join(','));
		}

	};
}

